// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"58":"1ff75f2d","214":"b39a97d6","369":"9b7a3a80","386":"87a02ba1","458":"89713543","577":"66801e42","652":"34876035","682":"d5252985","783":"c66ca607","787":"7783b8ed","812":"e16e9c63","867":"45b60ba7","904":"0c67cfd9","985":"de897744","997":"f8c56c24"}[chunkId] + ".js";
};